import type { CaseResultRecord, ToCollectionItem } from '@/lib/blocks/collection/records';
import { readMoreButton } from './button';
import { caseResultHref } from './links';

export const caseResultToCollectionItem: ToCollectionItem<CaseResultRecord> = (
  caseResult,
  index,
  isPreview,
) => {
  const path = caseResultHref(caseResult, isPreview);

  return {
    id: caseResult.id || caseResult.path || `case-result-${index}`,
    path,
    practiceAreas: caseResult.practiceAreas ?? [],
    title: caseResult.title ?? '',
    summary: caseResult.summary ?? '',
    attorneys: caseResult.attorneys ?? [],
    courts: caseResult.courts ?? [],
    button: readMoreButton(path),
  };
};
